import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, Calendar, User, Loader2 } from "lucide-react";
import { getBlogPost } from "../services/api";
import { PublicNavbar, PublicFooter } from "./PublicLayout";
import "./LandingPage.css";
import "./Blog.css";

function BlogDetail() {
  const { slug } = useParams();
  const { t } = useTranslation();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadPost();
  }, [slug]);

  const loadPost = async () => {
    try {
      setLoading(true);
      const data = await getBlogPost(slug);
      if (data.success) {
        setPost(data.post);
      } else {
        setError(true);
      }
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <div className="landing-page">
      <PublicNavbar />

      {loading ? (
        <div className="blog-loading">
          <Loader2 size={28} className="spinner" />
        </div>
      ) : error || !post ? (
        <div className="blog-empty" style={{ minHeight: "50vh" }}>
          <h3>{t("blog.notFound")}</h3>
          <p>{t("blog.notFoundDesc")}</p>
          <Link to="/blog" className="blog-detail-back" style={{ marginTop: 16 }}>
            <ArrowLeft size={16} />
            {t("blog.backToList")}
          </Link>
        </div>
      ) : (
        <div className="blog-detail">
          <Link to="/blog" className="blog-detail-back">
            <ArrowLeft size={16} />
            {t("blog.backToList")}
          </Link>

          {post.cover_image_url && (
            <img
              src={post.cover_image_url}
              alt={post.title}
              className="blog-detail-cover"
            />
          )}

          <div className="blog-detail-meta">
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <Calendar size={14} />
              {formatDate(post.created_at)}
            </span>
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <User size={14} />
              {post.author_name}
            </span>
          </div>

          <h1 className="blog-detail-title">{post.title}</h1>

          <div
            className="blog-detail-content"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />
        </div>
      )}

      <PublicFooter />
    </div>
  );
}

export default BlogDetail;
